import './hero.scss';
import 'slick-carousel';
import AOS from 'aos';

export default () => {
	AOS.init( {
		duration: 800,
		once: true,
	} );
	$( '.js-hero-slider' ).slick( {
		autoplay: true,
		autoplaySpeed: 8000,
		dots: false,
		arrows: false,
		infinite: true,
		fade: true,
	} );
};
